import React, { useEffect, useRef, useState } from "react";
import "./CreateSitesGlobal.scss";

import { Button, Form, Modal, InputGroup } from "react-bootstrap";
import { DomainAdd } from "@mui/icons-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  BASE_URL,
  PPE_getApiSync,
  getValueFromLocalStorageFunc,
  notify,
} from "../../../services/functions";
import { ToastContainer } from "react-toastify";
import {
  faPencil,
  faPlus,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";

const ModalCreateUsers = (props) => {
  const { par_show, status, row, outChange } = props;

  const [show, setShow] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const refEmailInput = useRef<HTMLInputElement | null>(null);
  const [roleList, setRoleList] = useState<
    { id: number; name: string; description: string }[]
  >([]);

  const reverseRoleMap = {
    superadmin: 1,
    user: 2,
    admin: 3,
  };

  const [objValueInput, setObjValueInput] = useState({
    email: "",
    name: "",
    password: "",
    is_active: true,
    role: 2,
  });

  const [errorEmail, setErrorEmail] = useState("");
  const [errorName, setErrorName] = useState("");

  useEffect(() => {
    setShow(par_show ?? false);

    // Fetch roles from API
    const token = getValueFromLocalStorageFunc("IOT_TOKEN") ?? "";
    const rolesEndpoint = `${BASE_URL}/v1/roles/list`;

    PPE_getApiSync(rolesEndpoint, null, "application/json", "GET", token)
      .then((res) => {
        if (Array.isArray(res)) {
          setRoleList(res);
        } else {
          notify("error", "Failed to fetch role list", "TOP_CENTER");
        }
      })
      .catch((err) => {
        console.error("❌ Error fetching roles:", err);
        notify("error", "Network error fetching roles", "TOP_CENTER");
      });

    if (status === "Edit" && row) {
      setObjValueInput({
        email: row.email ?? "",
        name: row.name ?? "",
        password: "",
        is_active: typeof row.is_active === "boolean" ? row.is_active : true,
        role:
          typeof row.role === "string" && reverseRoleMap[row.role.toLowerCase()]
            ? reverseRoleMap[row.role.toLowerCase()]
            : 2,
      });
    } else {
      setObjValueInput({
        email: "",
        name: "",
        password: "",
        is_active: true,
        role: 2,
      });
    }

    // reset error saat buka modal
    setErrorEmail("");
    setErrorName("");

    setTimeout(() => {
      if (refEmailInput.current) {
        refEmailInput.current.focus();
        refEmailInput.current.select();
      }
    }, 100);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [par_show, status, row]);

  const handleHide = () => {
    setShow(false);
    outChange(false);
  };

  const handleChangeInput = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >,
    tipeInput: string,
  ) => {
    let value: any = event.target.value;

    if (tipeInput === "is_active") {
      value = (event.target as HTMLInputElement).checked;
    } else if (tipeInput === "role") {
      value = Number(value);
    }

    setObjValueInput((obj) => ({
      ...obj,
      [tipeInput]: value,
    }));

    // reset error on change
    if (tipeInput === "email") setErrorEmail("");
    if (tipeInput === "name") setErrorName("");
  };

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = () => {
    const token = getValueFromLocalStorageFunc("IOT_TOKEN") ?? "";
    const methodhit = status === "Create" ? "POST" : "PUT";
    const endpoint =
      status === "Create"
        ? `${BASE_URL}/v1/users/create`
        : `${BASE_URL}/v1/users/update`;

    // Cek berbagai kemungkinan field ID untuk edit
    let userId =
      row?.id ||
      row?.["user_id"] ||
      row?.["userId"] ||
      row?.["ID"] ||
      row?.["Id"];

    // Validasi ID harus ada untuk edit
    if (status === "Edit" && !userId) {
      console.error("CRITICAL: No ID found in row data for edit operation!");
      console.log("Available row keys:", Object.keys(row || {}));
      console.log("Row data:", row);

      // Fallback: gunakan index atau generate ID sementara
      userId = row?.["index"] || Date.now() || Math.random() * 1000;
      console.warn("Using fallback ID:", userId);
    }

    // Pastikan ID adalah number
    if (status === "Edit") {
      userId = parseInt(userId) || userId;
    }

    const objSubmitToAPI = {
      ...(status === "Edit" && { id: userId }),
      email: objValueInput.email,
      name: objValueInput.name,
      password: objValueInput.password,
      is_active: objValueInput.is_active,
      role: objValueInput.role,
    };

    // Debug log untuk melihat data yang dikirim
    console.log("=== EDIT USER DEBUG (CreateUsers) ===");
    console.log("Status:", status);
    console.log("Row data:", row);
    console.log("Row keys:", Object.keys(row || {}));
    console.log("User ID found:", userId);
    console.log("User ID type:", typeof userId);
    console.log("Submit data:", objSubmitToAPI);
    console.log("Payload JSON:", JSON.stringify(objSubmitToAPI, null, 2));
    console.log("=== END DEBUG ===");

    PPE_getApiSync(
      endpoint,
      objSubmitToAPI,
      "application/json",
      methodhit,
      token,
    )
      .then((response) => {
        //console.log("✅ Response from API:", response);

        if (response?.detail === "user existed") {
          notify("warning", "Email atau nama sudah digunakan.", "TOP_CENTER");
          return;
        }

        if (response?.detail === "user created") {
          notify("success", "User berhasil dibuat!", "TOP_CENTER");
          setShow(false);
          outChange({
            tipe: "close_after_success_save",
            value: false,
            form: "create",
          });
          return;
        }

        if (response?.detail === "user update") {
          notify("success", "User berhasil diupdate!", "TOP_CENTER");
          setShow(false);
          outChange({
            tipe: "close_after_success_save",
            value: false,
            form: "edit",
          });
          return;
        }

        // fallback jika response tidak sesuai
        notify("error", "Unexpected response from server.", "TOP_CENTER");
      })
      .catch((err) => {
        console.error("❌ Error saat submit:", err);
        notify(
          "error",
          "An error occurred. Please try again later.",
          "TOP_CENTER",
        );
      });
  };

  return (
    <>
      <Modal show={show} centered size="sm" backdrop={true} onHide={handleHide}>
        <Modal.Header
          className={`modalheader modal-header-global ${
            status === "Edit" ? "edit" : "create"
          }`}
        >
          <Modal.Title className={`dashboard-modal-title`}>
            {status === "Create" ? (
              <>
                <DomainAdd
                  style={{
                    position: "absolute",
                    right: 15,
                    top: 25,
                    zIndex: 0,
                    transform: "scale(1.5)",
                  }}
                  className={`login-dropdown-icon`}
                />
                <FontAwesomeIcon
                  icon={faPlus}
                  className={`login-dropdown-icon`}
                  color={"darkgreen"}
                  style={{
                    position: "absolute",
                    right: 0,
                    top: 10,
                    zIndex: 0,
                    transform: "scale(1.5)",
                  }}
                />
              </>
            ) : (
              <>
                <DomainAdd
                  style={{
                    position: "absolute",
                    right: 20,
                    top: 25,
                    zIndex: 0,
                    transform: "scale(1.5)",
                  }}
                  className={`login-dropdown-icon`}
                />
                <FontAwesomeIcon
                  icon={faPencil}
                  className={`login-dropdown-icon`}
                  color={"darkgreen"}
                  style={{
                    position: "absolute",
                    right: -2,
                    top: 15,
                    zIndex: 0,
                    transform: "scale(1.5)",
                  }}
                />
              </>
            )}
            <span className="login-icon-modal-title">
              {status === "Create" ? "Create User" : "Edit User"}
            </span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="row">
            <Form.Group className="mb-1 col-12" controlId="id-email">
              <Form.Label className="mb-1 dash-modal-form-label required">
                Email
              </Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                maxLength={100}
                ref={refEmailInput}
                value={objValueInput.email}
                onChange={(e) => handleChangeInput(e, "email")}
                isInvalid={!!errorEmail}
              />
              {errorEmail && (
                <Form.Text className="text-danger">{errorEmail}</Form.Text>
              )}
            </Form.Group>

            <Form.Group className="mb-1 col-12" controlId="id-name">
              <Form.Label className="mb-1 dash-modal-form-label required">
                Name
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                maxLength={100}
                value={objValueInput.name}
                onChange={(e) => handleChangeInput(e, "name")}
                isInvalid={!!errorName}
              />
              {errorName && (
                <Form.Text className="text-danger">{errorName}</Form.Text>
              )}
            </Form.Group>

            <Form.Group className="mb-1 col-12" controlId="id-password">
              <Form.Label className="mb-1 dash-modal-form-label required">
                Password {status === "Edit" && "(Leave blank to keep current)"}
              </Form.Label>
              <InputGroup>
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder={
                    status === "Edit"
                      ? "New password (optional)"
                      : "Enter password"
                  }
                  maxLength={100}
                  value={objValueInput.password}
                  onChange={(e) => handleChangeInput(e, "password")}
                  autoComplete="new-password"
                />
                <Button
                  variant="outline-secondary"
                  onClick={toggleShowPassword}
                  tabIndex={-1}
                >
                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </Button>
              </InputGroup>
            </Form.Group>

            <Form.Group className="mb-1 col-12" controlId="id-is-active">
              <Form.Check
                type="checkbox"
                label="Is Active"
                checked={objValueInput.is_active}
                onChange={(e) => handleChangeInput(e, "is_active")}
              />
            </Form.Group>

            <Form.Group className="mb-1 col-12" controlId="id-role">
              <Form.Label className="mb-1 dash-modal-form-label required">
                Role
              </Form.Label>
              {/* <Form.Select
                value={objValueInput.role}
                onChange={(e) => handleChangeInput(e, "role")}
              >
                <option value={1}>1 - Superadmin</option>
                <option value={2}>2 - User</option>
                <option value={3}>3 - Admin</option>
              </Form.Select> */}
              <Form.Select
                value={objValueInput.role}
                onChange={(e) => handleChangeInput(e, "role")}
              >
                <option value="">Select Role</option>
                {roleList.map((role) => (
                  <option key={role.id} value={role.id}>
                    {role.id} - {role.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleSubmit}>
            Save
          </Button>
          <Button variant="secondary" onClick={handleHide}>
            Close
          </Button>
        </Modal.Footer>

        <ToastContainer draggable pauseOnHover />
      </Modal>
    </>
  );
};

export default ModalCreateUsers;
